/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Upgrade_DescInputs */

const en_tts_tool_upgrade_desc = /** @type {(inputs: Tts_Tool_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert full PDFs, articles, and research papers inside the Listening app.`)
};

const es_tts_tool_upgrade_desc = /** @type {(inputs: Tts_Tool_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte PDFs completos, artículos y papers de investigación dentro de la app Listening.`)
};

/**
* | output |
* | --- |
* | "Convert full PDFs, articles, and research papers inside the Listening app." |
*
* @param {Tts_Tool_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_upgrade_desc = /** @type {((inputs?: Tts_Tool_Upgrade_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Upgrade_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_upgrade_desc(inputs)
	return en_tts_tool_upgrade_desc(inputs)
});